const translations = {
  "en": {
    "Indicators": "Indicators",
    "Sentiment": "Sentiment",
    "Signal": "Signal",
    "Value": "Value"
  },
  "zh-tw": {
    "Indicators": "指標",
    "Sentiment": "市場情緒",
    "Signal": "訊號",
    "Value": "數值"
  }
};

export default translations;
